import { Link } from "react-router-dom";

export default function Footer() {
  const quickLinks = [
    { label: "Home", path: "/" },
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Care Plans", path: "/care-plans" },
    { label: "Pricing", path: "/pricing" },
    { label: "Reviews", path: "/reviews" },
    { label: "FAQ", path: "/faq" },
    { label: "Resources", path: "/resources" },
    { label: "Service Areas", path: "/service-areas" },
    { label: "Careers", path: "/careers" },
    { label: "Contact Us", path: "/contact" },
  ];

  const services = [
    { label: "Personal Care", path: "/services#personal-care" },
    { label: "Companionship", path: "/services#companion" },
    { label: "Meal Preparation", path: "/services#homemaker" },
    { label: "Medication Reminders", path: "/services#personal-care" },
    { label: "Private Duty", path: "/services#private-duty" },
    { label: "Light Housekeeping", path: "/services#homemaker" },
  ];

  return (
    <footer className="bg-brand-green-900 text-white">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          {/* Company Info */}
          <div className="sm:col-span-2 lg:col-span-1">
            <div className="flex items-center gap-2.5 mb-4">
              <img
                src="https://static.readdy.ai/image/2f07940fa5d3a90c9fe64cfd1f3be31d/a5100fd298f183af8516edaf12c4c388.png"
                alt="Sycamore Oasis Home Care Services"
                className="h-10 w-auto object-contain"
              />
              <div>
                <span className="text-base font-semibold text-white leading-tight block">
                  Sycamore Oasis
                </span>
                <span className="text-[10px] font-medium uppercase tracking-wider text-brand-green-300 block">
                  Home Care Services
                </span>
              </div>
            </div>
            <p className="text-sm text-brand-green-200 leading-relaxed mb-4">
              Helping you live better, every day. Compassionate non-medical home care services in Naperville, Illinois and surrounding counties.
            </p>
            <div className="flex items-center gap-1 text-brand-green-300">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-map-pin-line text-sm" />
              </div>
              <span className="text-xs">4055 S Route 59, Suite 121, Naperville, IL</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white mb-4">
              Quick Links
            </h4>
            <div className="grid grid-cols-2 gap-x-6 gap-y-2">
              {quickLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-sm text-brand-green-200 hover:text-white transition-colors duration-200"
                >
                  {link.label}
                </Link>
              ))}
            </div>
          </div>

          {/* Services */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white mb-4">
              Our Services
            </h4>
            <ul className="space-y-2">
              {services.map((service) => (
                <li key={service.label}>
                  <Link
                    to={service.path}
                    className="text-sm text-brand-green-200 hover:text-white transition-colors duration-200"
                  >
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact & Hours */}
          <div>
            <h4 className="text-sm font-semibold uppercase tracking-wider text-white mb-4">
              Contact Us
            </h4>
            <div className="space-y-3">
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-phone-line text-sm text-brand-green-300" />
                </div>
                <div>
                  <p className="text-sm text-white font-medium">Phone</p>
                  <p className="text-xs text-brand-green-200">773-699-7894 (24/7)</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-mail-line text-sm text-brand-green-300" />
                </div>
                <div>
                  <p className="text-sm text-white font-medium">Email</p>
                  <p className="text-xs text-brand-green-200">info@sycamoreoasis.com</p>
                </div>
              </div>
              <div className="flex items-start gap-2">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5 shrink-0">
                  <i className="ri-time-line text-sm text-brand-green-300" />
                </div>
                <div>
                  <p className="text-sm text-white font-medium">Office Hours</p>
                  <p className="text-xs text-brand-green-200">Mon – Friday: 9:00 AM – 5:00 PM</p>
                  <p className="text-xs text-brand-green-200">24 Hours On-call</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-10 md:mt-12 pt-6 border-t border-brand-green-700 flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex flex-col sm:flex-row items-center gap-3 sm:gap-6">
            <p className="text-xs text-brand-green-300">
              © 2026 Sycamore Oasis. All rights reserved.
            </p>
            <a
              href="https://www.google.com/maps/place/Sycamore+Oasis+Corp/@41.7290238,-88.2567613,652m/data=!3m1!1e3!4m8!3m7!1s0x17c800fd433d29:0xaa26cec045b66f09!8m2!3d41.7290238!4d-88.2567613!9m1!1b1!16s%2Fg%2F11twvlbqj3?entry=ttu"
              target="_blank"
              rel="noopener noreferrer nofollow"
              className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-brand-green-800 border border-brand-green-700 hover:bg-brand-green-700 transition-colors"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-google-fill text-sm text-white/80" />
              </div>
              <span className="text-[11px] font-medium text-white/80 whitespace-nowrap">See Us on Google Maps</span>
            </a>
          </div>
          <div className="flex items-center gap-4">
            <div className="hidden sm:flex items-center gap-1.5 mr-2">
              <div className="flex items-center gap-0.5">
                {Array.from({ length: 5 }).map((_, i) => (
                  <div key={i} className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-star-fill text-[10px] text-gold-accent" />
                  </div>
                ))}
              </div>
              <span className="text-[11px] font-semibold text-brand-green-300">4.9 · 47 Google Reviews</span>
            </div>
            <a
              href="#"
              rel="nofollow"
              className="text-brand-green-300 hover:text-white transition-colors"
              aria-label="Facebook"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-facebook-fill text-lg" />
              </div>
            </a>
            <a
              href="#"
              rel="nofollow"
              className="text-brand-green-300 hover:text-white transition-colors"
              aria-label="Instagram"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-instagram-line text-lg" />
              </div>
            </a>
            <a
              href="#"
              rel="nofollow"
              className="text-brand-green-300 hover:text-white transition-colors"
              aria-label="LinkedIn"
            >
              <div className="w-8 h-8 flex items-center justify-center">
                <i className="ri-linkedin-fill text-lg" />
              </div>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}